import * as uuidv4 from 'uuid/v4';

interface MultiroleLinkAttr {
  readonly id: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly kind: MultiroleLinkKind;
  readonly title: string;
  readonly color: string;
  readonly reference: string;
}

export enum MultiroleLinkKind {
  Web,
  File,
  Page,
}

type MultiroleLinkTypeFile = string;
type MultiroleLinkTypePage = string;
type MultiroleLinkTypeWeb = string;

interface MultiroleLinkAttrFile {
  kind: MultiroleLinkKind.File;
  file: MultiroleLinkTypeFile;
}

interface MultiroleLinkAttrPage {
  kind: MultiroleLinkKind.Page;
  page: MultiroleLinkTypePage;
}

interface MultiroleLinkAttrWeb {
  kind: MultiroleLinkKind.Web;
  url: MultiroleLinkTypeWeb;
}

type MultiroleLinkFile = MultiroleLinkAttr & MultiroleLinkAttrFile;
type MultiroleLinkPage = MultiroleLinkAttr & MultiroleLinkAttrPage;
type MultiroleLinkWeb = MultiroleLinkAttr & MultiroleLinkAttrWeb;
export type MultiroleLinkInfo = MultiroleLinkWeb | MultiroleLinkFile | MultiroleLinkPage;

interface MultiroleLinkCreateAttr {
  readonly kind: MultiroleLinkKind;
  readonly title: string;
  readonly color: string;
  readonly reference: string;
}

type MultiroleLinkCreateFile = MultiroleLinkCreateAttr & MultiroleLinkAttrFile;
type MultiroleLinkCreatePage = MultiroleLinkCreateAttr & MultiroleLinkAttrPage;
type MultiroleLinkCreateWeb = MultiroleLinkCreateAttr & MultiroleLinkAttrWeb;
export type MultiroleLinkCreateInfo = MultiroleLinkCreateWeb | MultiroleLinkCreateFile |
  MultiroleLinkCreatePage;

export function createMultiroleLinkInfoFromMultiroleLinkCreateInfo(
  multiroleLink: MultiroleLinkCreateInfo,
): MultiroleLinkInfo {
  const date = new Date();
  return {
    ...multiroleLink,
    id: uuidv4(),
    createdAt: date.toISOString(),
    updatedAt: date.toISOString(),
  };
}
